import { Form, Formik } from 'formik';
import { Modal } from 'app/shared/components/modals/Modal';
import { configurationTableValidationSchema } from '../constants';
import { IConfiguration } from '../types';
import { dateNow } from '../../../Tools/ProductRules/constants';
import { ConfigurationTableForm } from './ConfigurationTableForm';

interface IConfigurationTableModalProps {
  configuartionModalPosition: number;
  handleSubmit: (data: IConfiguration) => Promise<void>;
  currentConfiguration: IConfiguration | null;
  handleClose: () => void;
}

export const ConfigurationTableModal = ({
  configuartionModalPosition,
  handleSubmit,
  currentConfiguration,
  handleClose,
}: IConfigurationTableModalProps) => {
  const initialConfigurationState: IConfiguration = {
    id: currentConfiguration?.id || '',
    configurationGroup: currentConfiguration?.configurationGroup || '',
    tokenName: currentConfiguration?.tokenName || '',
    value: currentConfiguration?.value || '',
    isActive: currentConfiguration?.isActive || false,
    description: currentConfiguration?.description || '',
    updatedDate: dateNow,
  };

  return (
    <Modal
      hideBackdrop
      title="Add / Edit configuration"
      open={!!configuartionModalPosition} 
      resetPosition={configuartionModalPosition}
      dialogWidth="700px" 
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialConfigurationState as IConfiguration}
        validationSchema={configurationTableValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <ConfigurationTableForm handleClose={handleClose} {...props} />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
